import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./contact.css";
import ThinFooter from "../Footer/ThinFooter";
import axiosInstance from "../../axiosInstance";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";

const Contact = () => {
    // Form State
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        message: "",
    }); 

    // Validation State
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    // Fetch user data on mount
    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const token = localStorage.getItem("token"); // Get token from localStorage
                const response = await axiosInstance.get("/users/currentUser", {
                    headers: { Authorization: token },
                });

                if (response.data.success && response.data.data.user) {
                    const user = response.data.data.user;
                    setFormData({
                        firstName: user.firstName || "",
                        lastName: user.lastName || "",
                        email: user.email || "",
                        message: "",
                    });
                }
            } catch (error) {
                console.error("Error fetching user profile:", error);
            }
        };

        fetchUserProfile();
    }, []);

    // Handle Input Change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Validate Fields
    const validateFields = () => {
        let errors = {};
        if (!formData.firstName.trim()) errors.firstName = "First Name is required";
        if (!formData.lastName.trim()) errors.lastName = "Last Name is required";
        if (!formData.email.trim()) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = "Invalid email format";
        }
        if (!formData.message.trim()) errors.message = "Message is required";

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // Handle Form Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage("");
        setErrorMessage("");

        if (!validateFields()) return;

        setLoading(true);
        try {
            const token = localStorage.getItem("token"); // Get token from localStorage
            const response = await axiosInstance.post(
                "/users/sendContactForm",
                formData,
                {
                    headers: {
                        Authorization: token, // Include token in request headers
                    },
                }
            );

            if (response.status === 200) {
                setSuccessMessage("Your message has been sent successfully!");
                setFormData({ firstName: "", lastName: "", email: "", message: "" });
                setErrors({});
            }
        } catch (error) {
            setErrorMessage("Something went wrong, please try again later.");
        }
        setLoading(false);
    };

    return (
        <ContentWrapper>
            <Container fluid>
                <hr />
                <section className="section-padding">
                    <div>
                        <Row>
                            <Col lg={12} md={12} className="section-title text-left mb-4">
                                <h2>Contact Us</h2>
                            </Col>

                            <Form className="col-lg-12 col-md-12 cnt_frm" noValidate onSubmit={handleSubmit}>
                                {/* First & Last Name */}
                                <Row>
                                    <Col xs={12} sm={6}>
                                        <Form.Group controlId="first-name">
                                            <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                name="firstName"
                                                placeholder="First Name" 
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                isInvalid={!!errors.firstName}
                                                required 
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.firstName}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} sm={6}>
                                        <Form.Group controlId="last-name">
                                            <Form.Label className="ls_nm">
                                                Last Name <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                name="lastName"
                                                placeholder="Last Name" 
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                isInvalid={!!errors.lastName}
                                                required 
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.lastName}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Email Address */}
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="email">
                                            <Form.Label>Email Address <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="email" 
                                                name="email"
                                                placeholder="Email Address" 
                                                value={formData.email}
                                                onChange={handleChange}
                                                isInvalid={!!errors.email}
                                                required 
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Message */}
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="message">
                                            <Form.Label>How can we help?</Form.Label>
                                            <Form.Control 
                                                as="textarea" 
                                                rows={4} 
                                                name="message"
                                                placeholder=""
                                                value={formData.message}
                                                onChange={handleChange}
                                                isInvalid={!!errors.message}
                                                required 
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Success & Error Messages */}
                                {successMessage && <p className="text-success">{successMessage}</p>}
                                {errorMessage && <p className="text-danger">{errorMessage}</p>}

                                {/* Submit Button */}
                                <Button variant="danger" className="mt-3 cnt_btn" type="submit" disabled={loading}>
                                    {loading ? "Submitting..." : "Submit"}
                                </Button>
                            </Form>
                        </Row>
                    </div>
                </section>
            </Container>
            <ThinFooter />
        </ContentWrapper>
    );
};

export default Contact;
